/* eslint-disable @stripe-internal/stripe/no-mixed-react-exports */ // To replace the Consumer/hook when using this context in a shallow test, add this code above
// the top-most describe block
//
// jest.mock('@stripe-internal/ark-lib/dist/context/ArkFormContext', () =>
//   require('@stripe-internal/ark-lib/dist/context/ArkFormContext/testHelpers'),
// );
import * as React from 'react';
const ArkFormContext = /*#__PURE__*/ React.createContext({
    context: ()=>({}),
    disabledFields: [],
    disableAllFields: false,
    form: {
        fieldErrors: {},
        errorMessage: undefined,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setValue: ()=>{},
        touched: false,
        submittable: false,
        values: {},
        formErrors: undefined,
        unsafeApi: undefined
    },
    persistedValues: {},
    country: '',
    getFieldErrors: (_fieldId)=>[],
    registeredFields: new Set()
});
ArkFormContext.displayName = 'ArkFormContext';
export function useArkFormContext() {
    return React.useContext(ArkFormContext);
}
export function ArkFormContextConsumer(props) {
    const context = useArkFormContext();
    return props.children(context);
}
export const ArkFormContextProvider = ArkFormContext.Provider;

//# sourceMappingURL=ArkFormContext.js.map